import { DashboardState } from "../rootReducerTypes";
import { DashboardActionTypes, UpdateDashboardTitleAction, UpdateDashboardTitleActionPayload, UPDATE_DASHBOARD_TITLE } from "../reducersAndActionsType/dashboardActionAndReducerTypes";


export function updateDashboardTitle(payload: UpdateDashboardTitleActionPayload): UpdateDashboardTitleAction {
  return {
    type: UPDATE_DASHBOARD_TITLE,
    updateDashboardTitleActionPayload: payload,
  };
}

export default function dashboardReducer(state: DashboardState = initialState, action: DashboardActionTypes): DashboardState {
  switch (action.type) {
    case 'UPDATE_DASHBOARD_TITLE':
      return {
        ...state,
        title: action.updateDashboardTitleActionPayload.title
      };
    default:
      return state;
  }
}

export const initialState: DashboardState = {
  title: ''
};